import { defineStore } from 'pinia';

export const useExtraBreadcrumbStore = defineStore({
  id: 'extraBreadcrumb',
  state: () => ({
    extraBreadcrumb: '小柳丁的故事', // 屬於哪一個題組 mom, home-care
  }),

  actions: {
    setExtraBreadcrumb(value) {
      this.extraBreadcrumb = value;
    },
  },
});

export const a = '';
